/**
 * 公共接口
 * 2018-11-15 wmm
 */

import axios from 'axios'
import fetch from '../utils/fetch'
import qs from 'qs'

// page 组件保存
export const uploadPoto = process.env.BASE_API + '/common/upload/pic'

// 高级搜索
export function advancedSearch(data) {
  return fetch({
    url: '/fanews/search/AdvancedSearch',
    method: 'post',
    data
  })
}
// 新闻详情
export function getArticle(params) {
  return fetch({
    url: '/fanews/Search/GetArticle',
    method: 'get',
    params
  })
}
// 新闻详情
export function getArticleChart(params) {
  return fetch({
    url: '/fanews/Home/GetArticleMediaFocusChartData',
    method: 'get',
    params
  })
}
// 推荐-获取子分类和频道
export function getChannel(params) {
  return fetch({
    url: '/fanews/Recommend/GetChannel',
    method: 'get',
    params
  })
}
// 栏目文章搜索
export function searchByChannelid(data) {
  return fetch({
    url: '/fanews/search/SearchByChannelid',
    method: 'post',
    data
  })
}
// 栏目文章搜索
export function getChannelRuleList(params) {
  return fetch({
    url: '/fanews/Recommend/GetRuleList',
    method: 'get',
    params
  })
}
// 相似文章
export function searchBySameid(data) {
  return fetch({
    url: '/fanews/Search/SearchBySameid',
    method: 'post',
    data
  })
}
// 收藏文章
export function addCollection(data) {
  return fetch({
    url: '/fanews/Collection/Add',
    method: 'post',
    data
  })
}
// 取消收藏文章
export function cancelCollection(data) {
  return fetch({
    url: '/fanews/Collection/Cancel',
    method: 'post',
    data
  })
}

function loadScript(url) {
  return new Promise(function(resolve, reject) {
    let newScript = document.createElement('script')
    newScript.onerror = reject
    newScript.onload = resolve
    document.currentScript.parentNode.insertBefore(newScript, document.currentScript)
    newScript.src = url
  })
}
// 获取城市
export function getLocalCity(ip) {
  // let localAddress 特定https://ip.ws.126.net/ipquery会返回localAddress
  return loadScript('https://ip.ws.126.net/ipquery').then(res => {
    if (localAddress) {
      return {
        data: localAddress
      }
    }
    return { city: '杭州市', province: '浙江省' }
  })
  // fetch.get('https://ip.ws.126.net/ipquery?_=1560854058265')
}

export function getLocalColumn(params = {}) {
  return new Promise((resolve, reject) => {
    axios({
      url: '/static/cityMenus.json',
      method: 'get'
    }).then(res => {
      // debugger
      let { data } = res.data
      let relust = []
      if (params.provinces === 'all') {
        relust = data
      } else if (params.provinces) {
        relust = data.filter((item) => {
          return Number(item.parentId) === Number(params.provinces)
        })
      } else if (params.city) {
        params.city = params.city.replace(/省|市/g, '')
        relust = data.filter((item) => {
          let flag = item.name === params.city || (item.cname && item.cname.indexOf(params.city) >= 0)
          return flag && item.cid
        })
        resolve(relust[0])
        return
      } else {
        relust = data.filter((item) => {
          return !item.level
        })
      }
      resolve(relust)
    })
  })
}
